import { render, staticRenderFns } from "./GOList.vue?vue&type=template&id=202b8329"
import script from "./GOList.vue?vue&type=script&lang=js"
export * from "./GOList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports